import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "Kde to kúpim?",
        a: "Nikde. Zatiaľ. MAD je domáci projekt — žiadne obchody, žiadne sklady. Ak máš záujem, napíš a budeš medzi prvými, keď (a či) bude ďalšia várka.",
    },
    {
        q: "Koľko to stojí?",
        a: "Cena neexistuje. Edícia 1.0 sa nepredáva — ide ľuďom, ktorí sa ozvú prvý a sú v dosahu autora.",
    },
    {
        q: "Je v tom alkohol?",
        a: "Nie. MAD je nealkoholický. Šialený, ale nie opitý.",
    },
    {
        q: "Je v tom kofeín?",
        a: "Nie. Žiadny kofeín, žiadne energetické náhrady. Energiu si vyrobíš sám.",
    },
    {
        q: "Bude ďalšia edícia?",
        a: "Vydanie nie je isté. To je celá pointa.",
    },
    {
        q: "Môžem dostať recept?",
        a: "Vážne?",
    },
];

export const FAQ = () => {
    return (
        <section
            data-testid="faq-section"
            className="relative px-6 sm:px-10 py-24 sm:py-32 border-t border-white/10 bg-[#070707]"
        >
            <div className="max-w-[1400px] mx-auto">
                <div className="grid grid-cols-12 gap-10 mb-12">
                    <div className="col-span-12 lg:col-span-3">
                        <div className="text-[11px] uppercase tracking-[0.3em] text-[#D91C1C]">
                            05 / Otázky
                        </div>
                    </div>
                    <div className="col-span-12 lg:col-span-9">
                        <h2
                            data-testid="faq-heading"
                            className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.9] text-white"
                        >
                            Časté otázky.{" "}
                            <span className="text-white/40">
                                Stručné odpovede.
                            </span>
                        </h2>
                    </div>
                </div>

                <div className="max-w-4xl mx-auto">
                    <Accordion
                        type="single"
                        collapsible
                        className="w-full border-t border-white/10"
                    >
                        {FAQS.map((f, idx) => (
                            <AccordionItem
                                key={idx}
                                value={`faq-${idx}`}
                                data-testid={`faq-item-${idx + 1}`}
                                className="border-b border-white/10"
                            >
                                <AccordionTrigger className="font-display uppercase text-xl sm:text-2xl tracking-tight text-white hover:text-[#D91C1C] hover:no-underline py-7 text-left">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-base sm:text-lg text-white/70 leading-relaxed pb-7 pr-10">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
};
